var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeekbarPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.58 53.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb5757;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-seekbar"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.79,
    cy: 26.79,
    r: 26.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.13,24.2l-13.3-8.85a1.81,1.81,0,0,0-2.74,1.76V34.8a1.82,1.82,0,0,0,2.74,1.75l13.3-8.84A2.17,2.17,0,0,0,36.13,24.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekbarPlay);
export default __webpack_public_path__ + "static/media/seekbar-play.a6bae3901934b0d4fac3b5c769f2a2b7.svg";
export { ForwardRef as ReactComponent };